'use client'

import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { MyMangoLikesYouClientLink } from 'links/myMangoLikesYou/client/index'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useUserDetails } from 'user-data/hooks/useUserDetails'
import { cx } from 'utils/cx'

import styles from './LikesInfo.module.scss'
import text from 'fukku/styles/texts.module.scss'

export const LikesInfo = () => {
	const { t } = useLabels()
	const userDetails = useUserDetails()
	const { country, isShop } = useMasterData()
	const { enabled: mlyTiersEnabled } = useFeatureFlag(
		featureFlagKeys.MangoLikesYouClubTiers
	)

	if (!userDetails) {
		return null
	}
	const loyalty = userDetails.loyalty

	if (!loyalty) {
		return null
	}

	const { likes, isLoyalty } = loyalty

	const hasLikesInfo = isShop && country.isLoyalty && isLoyalty
	const tier = userDetails?.loyalty?.likes?.tier?.tier
	const showTiers = mlyTiersEnabled && tier

	return (
		hasLikesInfo && (
			<div
				className={cx(
					styles.likesInfo,
					!showTiers && styles.likesInfoWithoutTiers
				)}
			>
				<div className={styles.headerInfo}>
					<p className={`${text.uppercaseL} ${styles.title}`}>
						{t('profile.clubMLY.title')}
					</p>
					<MyMangoLikesYouClientLink className={styles.moreLink}>
						{t('profile.more.link')}
					</MyMangoLikesYouClientLink>
				</div>
				<p
					className={cx(
						showTiers ? text.bodyS : text.bodyM,
						styles.numberOfLikes,
						showTiers && styles.numberOfLikesWithTiers
					)}
				>
					{likes?.available && likes.available > 0 ? (
						<ClientLabel placeholderValues={{ 1: likes.available }}>
							{t('profile.clubMLY.balanceLikes.text')}
						</ClientLabel>
					) : (
						t('profile.clubMLY.balanceNoLikes.text')
					)}
				</p>
			</div>
		)
	)
}
